import {
  VoucherController
} from 'mutants-appfx';
import {
  tApi
} from 'tplus-api';
import {
  i18n,
  stores,
  reaction,
  action
} from 'mutants-microfx';
const t = i18n.getFixedT(null, 'newretail');
import {FeedbackType,dataSource,columns} from '../viewModels/FeedBackConst';

// 零售业务基类，公共的业务控制可以写在这里
export default class RetailBaseController extends VoucherController {
  /**
   * 初始化
   */
  constructor(...args)
  {
    super(...args);
  }



  /**
   *  统一的逻辑反馈机制start  支持以下四种形态
   */

   /**
    * 反馈机制的demo 模拟可用量不足的场景
    */
  async feedbackDemo(){
    const content = '以下商品的可用量不足';
    const check = async (form)=>{
      if('222222'!==form.authPwd){
        return '密码不正确';
      }
      console.log('执行检查操作',form);
    };
    let result = this.pwdAuth({content,check,columns,dataSource});
    if(result){
      console.log('执行后续逻辑');
    }else{
      console.log('中断逻辑');
    }
  }

  //反馈机制
  async inputFeedbackModal(feedbackType,title,content,dataSource,columns,check) {
    let promiseOvject= await new Promise((resolve, reject) => {
      let FeedBackModal = this.viewModel.getViewItem('FeedBackModal');
      FeedBackModal.inputForm({
        feedbackType,title,content,dataSource,columns,check
      }, resolve);
    });
    
    return promiseOvject;
  }
  /**
   * 确认状态  可以选择继续强制执行
   * @param {*} param0
   */
  async confirm({title,content,columns,dataSource,check}){
    const feedbackType = FeedbackType.Confirm;
    return await this.inputFeedbackModal(feedbackType,title,content,dataSource,columns,check);
  }

  /**
   * 禁止状态
   * @param {*} param0
   */
  async forbidden({title,content,columns,dataSource,check}){
    const feedbackType = FeedbackType.Forbidden;
    return await this.inputFeedbackModal(feedbackType,title,content,dataSource,columns,check);
  }

  /**
   * 密码校验状态
   * @param {*} param0
   */
  async pwdAuth({title,content,columns,dataSource,check}){
    const feedbackType = FeedbackType.PwdAuth;
    return await this.inputFeedbackModal(feedbackType,title,content,dataSource,columns,check);
  }

  /**
   * 其他用户校验
   * @param {*} param0
   */
  async otherAuth({title,content,columns,dataSource,check}){
    const feedbackType = FeedbackType.OtherAuth;
    return await this.inputFeedbackModal(feedbackType,title,content,dataSource,columns,check);
  }

  /**
   *获取弹出框的相关信息
   *
   * @returns
   * @memberof RetailBaseController
   */
  getPopupMethodInfomation()
  {
    let popupMethod = {};
    popupMethod.confirm = this.confirm;
    popupMethod.forbidden = this.forbidden;
    popupMethod.pwdAuth = this.pwdAuth;
    popupMethod.otherAuth = this.otherAuth;
    popupMethod.callObj = this;
    return popupMethod;
  }
  /**
   *  统一的逻辑反馈机制end
   */


}
